import { createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "budget-error-resolution" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "card border" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = {
  class: "row align-items-center",
  style: {"min-height":"80px"}
}
const _hoisted_6 = { class: "col-4 text-center" }
const _hoisted_7 = { class: "display-4 fw-bold text-dark mb-1" }
const _hoisted_8 = { class: "text-muted" }
const _hoisted_9 = { class: "col-7" }
const _hoisted_10 = { class: "mb-2" }
const _hoisted_11 = { class: "fw-semibold text-dark me-2" }
const _hoisted_12 = { class: "mb-2" }
const _hoisted_13 = { class: "fw-semibold text-dark me-2" }
const _hoisted_14 = { class: "small text-muted" }

import { computed } from "vue";


export default {
  __name: 'BookingBudgetErrorPanel',
  props: {
	budgetError: { type: Object, default: null },
},
  setup(__props) {

const props = __props;

const availablePoints = computed(() => {
	if (!props.budgetError?.budgetDetails) return 0;
	const { totalPoints, usedPoints } = props.budgetError.budgetDetails;
	return totalPoints - usedPoints;
});

const availableTimeText = computed(() => {
	const points = Math.max(0, availablePoints.value);
	const totalMinutes = points * 15; // 1 point = 15 minutes

	if (totalMinutes === 0) return "0 Minuten";

	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;

	if (hours === 0) {
		return `${minutes} ${minutes === 1 ? "Minute" : "Minuten"}`;
	} else if (minutes === 0) {
		return `${hours} ${hours === 1 ? "Stunde" : "Stunden"}`;
	} else {
		return `${hours} ${hours === 1 ? "Stunde" : "Stunden"} und ${minutes} ${
			minutes === 1 ? "Minute" : "Minuten"
		}`;
	}
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
        _createElementVNode("div", { class: "text-danger me-2" }, [
          _createElementVNode("i", { class: "fas fa-coins fa-lg" })
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("p", { class: "mb-1 fw-bold text-danger" }, " Nicht genügend Punkte verfügbar ")
        ])
      ], -1 /* CACHED */)),
      _createCommentVNode(" Budget Summary "),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createCommentVNode(" Available Points Section "),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(availablePoints.value), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_8, " von " + _toDisplayString(__props.budgetError?.budgetDetails?.totalPoints || 0) + " Punkten verfügbar ", 1 /* TEXT */)
            ]),
            _createCommentVNode(" Divider "),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-1 d-flex justify-content-center" }, [
              _createElementVNode("div", {
                class: "border-start",
                style: {"height":"60px","border-width":"2px !important"}
              })
            ], -1 /* CACHED */)),
            _createCommentVNode(" Usage Details "),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(__props.budgetError?.budgetDetails?.usedPoints || 0), 1 /* TEXT */),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "text-muted" }, "Punkte verwendet", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(__props.budgetError?.budgetDetails?.neededPoints || 0), 1 /* TEXT */),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-muted" }, "Punkte benötigt für diese Buchung", -1 /* CACHED */))
              ]),
              _createElementVNode("div", _hoisted_14, " Sie können noch " + _toDisplayString(availableTimeText.value) + " buchen ", 1 /* TEXT */)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

}